import { IAppActions } from '../types/IAppActions';
import {
  SET_WHATSAPP_RESTAURANT_STATE,
  SET_WHATSAPP_RESET_IS_LOADING,
  SET_WHATSAPP_IS_LOADING,
  SET_TG_RESTAURANT_STATE,
  SET_TG_RESET_IS_LOADING,
  SET_TG_PHONE_IS_LOADING,
  SET_TG_CODE_IS_LOADING,
  SET_TG_PASSWORD_IS_LOADING,
} from '../actions/guestmeNotifications/GuestmeNotificationsActionsTypes';

export const initState: GM.GuestmeNotifications.Store = {
  restaurants: {},
  whatsappIsLoading: false,
  whatsappResetIsLoading: false,
  tgIsLoading: false,
  tgResetIsLoading: false,
  tgPhoneIsLoading: false,
  tgCodeIsLoading: false,
  tgPasswordIsLoading: false,
};

export default function reducer(
  state: GM.GuestmeNotifications.Store = initState,
  action: IAppActions,
): GM.GuestmeNotifications.Store {
  switch (action.type) {
    case SET_TG_RESET_IS_LOADING:
      return {
        ...state,
        tgResetIsLoading: action.payload,
      };

    case SET_TG_PHONE_IS_LOADING:
      return {
        ...state,
        tgPhoneIsLoading: action.payload,
      };

    case SET_TG_CODE_IS_LOADING:
      return {
        ...state,
        tgCodeIsLoading: action.payload,
      };

    case SET_TG_PASSWORD_IS_LOADING:
      return {
        ...state,
        tgPasswordIsLoading: action.payload,
      };

    case SET_TG_RESTAURANT_STATE:
      const tgState = {
        ...state,
        restaurants: {
          ...state.restaurants,
          [action.payload.restaurantId]: {
            ...state.restaurants[action.payload.restaurantId],
            tg: action.payload,
          },
        },
      }

      if (action.payload.type === 'RESET_OK' || action.payload.type === 'AUTHORIZED' || action.payload.type === 'CONNECTION_CLOSED') {
        if (action.payload.type === 'RESET_OK' || action.payload.type === 'CONNECTION_CLOSED') {
          tgState['tgResetIsLoading'] = false;

          if (
            tgState[action.payload.restaurantId] &&
            tgState[action.payload.restaurantId]['tg']
          ) {
            tgState[action.payload.restaurantId]['tg'] = null;
          }
        }

        tgState['tgPhoneIsLoading'] = false;
        tgState['tgCodeIsLoading'] = false;
        tgState['tgPasswordIsLoading'] = false;

      } else if (action.payload.type === 'WAITING_PHONE') {
        tgState['tgCodeIsLoading'] = false;
        tgState['tgPasswordIsLoading'] = false;

      } else if (action.payload.type === 'WAITING_CODE') {
        tgState['tgPhoneIsLoading'] = false;
        tgState['tgPasswordIsLoading'] = false;

      } else if (action.payload.type === 'WAITING_PASSWORD') {
        tgState['tgPhoneIsLoading'] = false;
        tgState['tgCodeIsLoading'] = false;
      }

      return tgState;

    case SET_WHATSAPP_RESET_IS_LOADING:
      return {
        ...state,
        whatsappResetIsLoading: action.payload,
      };

    case SET_WHATSAPP_IS_LOADING:
      return {
        ...state,
        whatsappIsLoading: action.payload,
      };

    case SET_WHATSAPP_RESTAURANT_STATE:
      const whatsappState = {
        ...state,
        restaurants: {
          ...state.restaurants,
          [action.payload.restaurantId]: {
            ...state.restaurants[action.payload.restaurantId],
            whatsapp: action.payload,
          },
        },
      };

      if (
        action.payload.type === 'RESET_OK' ||
        action.payload.type === 'AUTHORIZED' ||
        action.payload.type === 'CONNECTION_CLOSED'
      ) {
        if (action.payload.type === 'RESET_OK' || action.payload.type === 'CONNECTION_CLOSED') {
          whatsappState['whatsappResetIsLoading'] = false;

          if (
            whatsappState[action.payload.restaurantId] &&
            whatsappState[action.payload.restaurantId]['whatsapp']
          ) {
            whatsappState[action.payload.restaurantId]['whatsapp'] = null;
          }
        }

        whatsappState['whatsappIsLoading'] = false;

      } else if (action.payload.type === 'QR_CODE') {
        whatsappState['whatsappIsLoading'] = false;
      }

      return whatsappState;

    default:
      return state;
  }
}
